import React from "react";
import { IForm } from "../../../../types/form.type";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { Controller, useForm } from "react-hook-form";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import ModalForm from "../../modal/ModalForm";
import { Box, Grid2 } from "@mui/material";
import SelectApiInput from "../../input/SelectApiInput";
import TextInput from "../../input/TextInput";
import CheckboxInput from "../../input/CheckboxInput";
import RichTextEditor from "../../text-editor/RichTextEditor";

const schema = yup.object({});

function FormForumPost({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const { showAlert } = useAlertContext();
  const defaultData: { [key: string]: any } = {
    topic: null,
    category: null,
    title: "",
    isPopular: false,
    slug: "",
    description: "",
  };
  const originData = defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
        topic: defaultValues?.topic
          ? {
              _id: defaultValues?.topic || "",
              name: defaultValues?.topic_name || "",
            }
          : null,
        category: defaultValues?.category
          ? {
              _id: defaultValues?.category || "",
              name: defaultValues?.category_name || "",
            }
          : null,
      }
    : defaultData;

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const handleReset = () => {
    reset(originData);
  };

  const generateDataPost = async (values: typeof defaultData) => {
    return values;
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost: { [key: string]: any } = await generateDataPost(values);
    let resp = null;
    if (isEdit) {
      resp = await asyncPutData({
        id: dataPost._id,
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    } else {
      resp = await asyncPostData({
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    }
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi lưu đối tượng",
      });
    } else {
      onClose();
      setLoad?.((prev: number) => prev + 1);
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="800px"
      formTitle="bài viết forum"
      loading={isSubmitting}
      open={open}
      isEdit={isEdit}
      onClose={onClose}
      onSubmit={onSubmit}
      onReset={handleReset}
    >
      <Box sx={{ px: 1 }}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 6 }}>
            <TextInput
              required
              label="Tiêu đề"
              name="title"
              register={register}
              labelWidth="30%"
              errorMessage={errors?.title?.message as string}
            />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <TextInput
              readOnly
              label="Slug"
              placeholder="Slug tạo tự động"
              name="slug"
              register={register}
              labelWidth="30%"
            />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <Controller
              control={control}
              name="category"
              render={({ field: { onChange, value } }) => (
                <SelectApiInput
                  required
                  label="Danh mục"
                  labelWidth="30%"
                  apiCode="socialcategories"
                  placeholder="Chọn danh mục"
                  searchFields={["name"]}
                  getOptionLabel={(option) => option.name}
                  checkEqual={(value, option) => value?._id === option?._id}
                  value={value}
                  onChange={onChange}
                  errorMessage={errors?.category?.message as string}
                />
              )}
            />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <Controller
              control={control}
              name="topic"
              render={({ field: { onChange, value } }) => (
                <SelectApiInput
                  required
                  label="Chủ đề"
                  labelWidth="30%"
                  apiCode="topics"
                  placeholder="Chọn chủ đề"
                  searchFields={["name"]}
                  getOptionLabel={(option) => option.name}
                  checkEqual={(value, option) => value?._id === option?._id}
                  value={value}
                  onChange={onChange}
                  errorMessage={errors?.topic?.message as string}
                />
              )}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Controller
              name="isPopular"
              control={control}
              render={({ field: { value, onChange } }) => {
                return (
                  <CheckboxInput
                    label="Nổi bật"
                    checked={value}
                    onChange={onChange}
                  />
                );
              }}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Controller
              name="description"
              control={control}
              render={({ field: { value, onChange } }) => {
                return <RichTextEditor value={value} onChange={onChange} />;
              }}
            />
          </Grid2>
        </Grid2>
      </Box>
    </ModalForm>
  );
}

export default FormForumPost;
